import * as React from 'react';

function ApiGatewayIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={72.36}
      height={72.36}
      viewBox='0 0 72.36 72.36'
      {...props}
    >
      <path
        id='Path_20'
        data-name='Path 20'
        d='M64.023,53.686a9.975,9.975,0,0,0-5.169,1.473l-7.985-8.011a15.506,15.506,0,0,0,0-17.935L58.854,21.2a9.975,9.975,0,0,0,5.169,1.473A10.337,10.337,0,1,0,53.686,12.337a9.975,9.975,0,0,0,1.473,5.169l-8.011,7.985a15.506,15.506,0,0,0-17.935,0L21.2,17.506a9.975,9.975,0,0,0,1.473-5.169A10.337,10.337,0,1,0,12.337,22.674,9.975,9.975,0,0,0,17.506,21.2l7.985,8.011a15.506,15.506,0,0,0,0,17.935l-7.985,8.011a9.975,9.975,0,0,0-5.169-1.473A10.337,10.337,0,1,0,22.674,64.023,9.975,9.975,0,0,0,21.2,58.854l8.011-7.985a15.506,15.506,0,0,0,17.935,0l8.011,7.985a9.975,9.975,0,0,0-1.473,5.169A10.337,10.337,0,1,0,64.023,53.686Zm0-46.517a5.169,5.169,0,1,1-5.169,5.169A5.169,5.169,0,0,1,64.023,7.169ZM7.169,12.337a5.169,5.169,0,1,1,5.169,5.169,5.169,5.169,0,0,1-5.169-5.169Zm5.169,56.854a5.169,5.169,0,1,1,5.169-5.169A5.169,5.169,0,0,1,12.337,69.191ZM38.18,48.517A10.337,10.337,0,1,1,48.517,38.18,10.337,10.337,0,0,1,38.18,48.517ZM64.023,69.191a5.169,5.169,0,1,1,5.169-5.169A5.169,5.169,0,0,1,64.023,69.191Z'
        transform='translate(-2 -2)'
        fill='#fff'
      />
    </svg>
  );
}
export default ApiGatewayIcon;
